/* eslint-disable react-refresh/only-export-components */
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return (
    <Suspense fallback={location.pathname === '/' ? (
      <div className="home-boot-poster" role="status" aria-label="브랜드 영상 준비 중">
        <picture>
          <source media="(max-width: 734px)" srcSet="/brand/film/life-mobile-v4.webp" />
          <img src="/brand/film/life-desktop-v1.webp" alt="" fetchPriority="high" />
        </picture>
      </div>
    ) : (
      <div className="flex min-h-screen items-center justify-center bg-white" role="status" aria-label="페이지 로딩 중">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-gray-200 border-t-gray-900" />
      </div>
    )}>
      {element}
    </Suspense>
  );
}
